import {Reference} from '../models';

export interface Favorite {
  id: string;
  reference: Reference
}
